import { combineReducers } from 'redux';

import tots from './tots';
import peticioObtenirEnCurs from './peticioObtenirEnCurs';
import idComentariEnProcesEliminar from './idComentariEnProcesEliminar';
import peticioInserirEnCurs from './peticioInserirEnCurs';
import textNouComentari from './textNouComentari';

export default combineReducers({
    tots,
    peticioObtenirEnCurs,
    idComentariEnProcesEliminar,
    peticioInserirEnCurs,
    textNouComentari
});



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/index.js